<template>
	
	<section class="hero">
		<div class="hero-body">
			<div class="container">
				<nav class="breadcrumb" aria-label="breadcrumbs">
					<ul>
						<li><router-link to="/">Notes de frais</router-link></li>
						<li><router-link :to="{ name: 'Ndf', params : {id:ndf.id} }">{{ ndf.libelle }}</router-link></li>
						<li class="is-active"><a>{{ depense.libelle }}</a></li>
					</ul>
				</nav>
				<template v-if="ndf && depense">
					<h2 class="title" v-html="ndf.libelle">
					</h2>
					<h2 class="subtitle">
						{{ ndf.support }} {{ ndf.projet }}
					</h2>

					<div class="box content">
						<article class="post">
							<h4>{{ depense.libelle }}</h4>
							<nav class="level is-size-7	is-mobile">
								<div class="level-item">
									HT: <span class="has-text-grey-light">{{ depense.HT }}</span>
								</div>
								<div class="level-item">
									TVA: <span class="has-text-grey-light">{{ depense.TVA }}</span>
								</div>
								<div class="level-item">
									TTC: <span class="has-text-grey-light">{{ depense.TTC }}</span>
								</div>
							</nav>
							<div class="media">
								<div class="media-left">
									{{ depense.type_depense_icone }}
								</div>
								<div class="media-content">
									<div class="content">
										<p>
											{{ depense.date }} &nbsp;
										</p>
									</div>
								</div>
								<div class="media-right">
									<code>{{ basename(depense.justificatif) }}</code>
								</div>
							</div>
						</article>
					</div>

					<template v-if="isIos">
					<button class="button is-loading is-warning" v-if="loading"> Chargement </button>
						<form v-else enctype="multipart/form-data" class="file is-primary">
							<label class="file-label">
								<input ref="file" @change="formUpload" class="file-input" type="file">
								<span class="file-cta">
									<span class="file-icon">
										<i class="fas fa-camera"></i>
									</span>
									<span class="file-label">
										Prendre en photo ou importer un document
									</span>
								</span>
							</label>
						</form>
					</template>
					<template v-else>
						<p>
							<button @click="demarrerCamera" class="button is-primary">
								<span class="icon is-small">
									<i class="fas fa-camera"></i>
								</span>
								<span>Prendre en photo un document</span>
							</button>
						</p><br>
						<button class="button is-loading is-warning" v-if="loading"> Chargement </button>
						<form v-else enctype="multipart/form-data" class="file is-warning">
							<label class="file-label">
								<input ref="file" @change="formUpload" class="file-input" type="file">
								<span class="file-cta">
									<span class="file-icon">
										<i class="fas fa-upload"></i>
									</span>
									<span class="file-label">
										Importer un fichier depuis le téléphone
									</span>
								</span>
							</label>
						</form>
					</template>

					<br>
					<router-link class="button is-light" :to="{ name: 'Ndf', params : {id:ndf.id} }">Annuler</router-link>

					<div class="modal is-active" v-if="camera">
						<div class="sources">
							<button @click="changerSource" class="button is-small is-rounded">
								<span class="icon is-small">
									<i class="fas fa-camera"></i>
								</span>
								<span class="icon is-small">
									<i class="fas fa-exchange-alt"></i>
								</span>
							</button>
						</div>
						<div class="modal-background"></div>
						<div class="modal-card">
							<canvas style="display:none" id="canvas"></canvas>  
							<div v-if="apercu"><img :src="image"></div>
							<template v-else>
								<video @click="capturer" id="video" autoplay></video>
							</template>
						</div>
						<button class="modal-close is-large" aria-label="close" @click="apercu=camera=false"></button>
						<div class="boutons-flottants">
							<template v-if="apercu">
								<button @click="enregistrer" class="button is-primary">
									<span class="icon is-small">
										<i class="fas fa-camera"></i>
									</span>
									<span>Enregistrer</span>
								</button>
								<button @click="annuler" class="button is-light">
									<span class="icon is-small">
										<i class="fas fa-times"></i>
									</span>
									<span>Annuler</span>
								</button>

							</template>
							<button v-else @click="capturer" class="button is-info">
								<span class="icon is-small">
									<i class="fas fa-camera"></i>
								</span>
								<span>Prendre la photo</span>
							</button>
						</div>
					</div>	
				</template>			
			</div>
		</div>
	</section>

</template>

<script>
	export default {
		name: 'Depense',
		data() {
			return {
				camera:false,
				apercu:false,
				depense:false,
				ndf:false,
				image:false,
				sources:[],
				source:0,
				video:false,
				loading:false,
				isIos:false
			}
		},
		mounted() {
			if( /iPhone|iPad|iPod/i.test(navigator.userAgent) ) {
				this.isIos=true;
			}
						
			this.isIos=true;

			window.axios.post('depenses',{clause : {
				id:this.$route.params.id
			}}).then(response => {
				this.depense = response.data.depenses[0]

				window.axios.post('ndf',{clause : {
					id:this.depense.ndf_id
				}}).then(response => {
					this.ndf = response.data.ndf[0]
					if(this.ndf.upload_mobile!=1) {
						this.retourNdf()
					}
				});
			});
		},
		methods : {
			formUpload() {
				this.loading=true;
				let file = this.$refs.file.files[0];
				window.axios.post('justificatif',{
					depense_id:this.depense.id,
					file : file
				}).then(response => {
					this.terminerEnvoi(response.data);
				});

			},
			terminerEnvoi(data) {
				if(data.justificatif.message) {
					alert(data.justificatif.message)
				}
				if(data.justificatif.depense) {
					this.retourNdf()
				}
				this.loading=false;
			},
			retourNdf() {
				this.$router.push({ name: "Ndf", params : {id : this.ndf.id} })
			},
			demarrerCamera() {
				this.camera=true;
				setTimeout(() => {
					this.video = document.querySelector('#video')

					navigator.mediaDevices.enumerateDevices().then(this.gotDevices).then(this.getStream).catch(this.handleError);
/*
					navigator.getUserMedia = ( navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia);



					if (navigator.getUserMedia) {
						navigator.getUserMedia ({
							video: true,
							audio: false
						},
						(localMediaStream) => {
							this.video.src = window.URL.createObjectURL(localMediaStream);
						},
						(err) => {
							console.log("The following error occured: " + err);
						});
					} else {
						console.log("getUserMedia not supported");
					}  */
				},100)
			},
			capturer() {
				let canvas = document.getElementById("canvas");
				let ctx = canvas.getContext('2d');

				let width = this.video.videoWidth;
				let height = this.video.videoHeight;				

				canvas.width = width;
				canvas.height = height;

				ctx.drawImage(this.video, 0,0, canvas.width, canvas.height);

				this.apercu=true;
				this.image = canvas.toDataURL('image/png');

			},
			annuler() {
				this.apercu=false;
				this.image=false;
				this.demarrerCamera();
			},
			enregistrer() {
				window.axios.post('justificatif',{
					depense_id:this.depense.id,
					image : this.image
				}).then(response => {
					this.terminerEnvoi(response.data);
				});

			},
			changerSource() {
				this.source++;
				if(this.source >= this.sources.length) {
					this.source=0;
				}
				this.demarrerCamera();
			},
			gotDevices(deviceInfos) {
				this.sources=[];
				for (var i = 0; i !== deviceInfos.length; ++i) {
					var deviceInfo = deviceInfos[i];
					if (deviceInfo.kind === 'videoinput') {
						this.sources.push({
							label : deviceInfo.label, 
							id : deviceInfo.deviceId
						});
					}
				}
			},
			getStream() {
				if (window.stream) {
					window.stream.getTracks().forEach(function(track) {
						track.stop();
					});
				}

				var constraints = {
					video: {
						deviceId: {exact: this.sources[this.source].id}
					}
				};

				navigator.mediaDevices.getUserMedia(constraints).
				then(this.gotStream).catch(this.handleError);
			},
			gotStream(stream) {
				window.stream = stream; 
				this.video.srcObject = stream;
			},			
			handleError(error) {
				console.log('Error: ', error);
			}

		}
	}
</script>

<style>
h2 small {
	display: block;
	font-size: smaller;
	color:#aaa;
}

.modal #video {
	width:100%;
	height: 100%;
}
.boutons-flottants {
	position: absolute;
	bottom: 15px
}
.sources {
	position: absolute;
	top: 15px;
	left: 15px;
	z-index: 1000;	
}
</style>


// WEBPACK FOOTER //
// src/components/Depense.vue